import { change, Field, FieldArray, formValueSelector, getFormMeta, reduxForm } from 'redux-form';
import { deletePatientAddress, getPatientAddressPhoneDetails, getPatientMasterData, getPatientPhoneById, savePatientAddressPhoneDetails, savePatientPhone } from './actions/PatientActions';
import {
  isValidApartmentWithSpace,
  isValidNameWithSpace,
  normalizeMobile,
  normalizeZipCode,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderTextField,
} from '../../components/reduxFields';
import { CommonButton } from '../../components/buttons';
import { connect } from 'react-redux';
import React from 'react';
import validate from './validate';
import GooglePlaceAutocomplete from '../../components/GooglePlaceAutocomplete';
import { CONVERGENCY, extractDataFromArrayByValue, showErrorMessage } from '../../actions/utilAction';


class Address extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      primary_address: null,
      mailing_address: null,
      patientId: props.patient_id,
      isAddAddress: false,
      masterState: [],
      masterCountry: [],
      masterLocationType: [],
      filteredPrimaryStatesByCountry: [],
      filteredMailingStatesByCountry: [],
      filteredAdditionalStatesByCountry: [],
      primaryAddressTypeID: null,
      mailingAddressTypeID: null,
      filteredMasterAddressType: [],
      masterPhoneType: [],
      masterPhonePreferences: [],
      isTabChangeRequest: false,
      firstTimeMsg: true,
      isValidPrimaryAddress: true,
      isValidMailingAddress: true,
      street_number: '',
      route: '',
      locality: '',
      administrative_area_level_1: '',
      country: '',
      postal_code: '',
      PrimaryAddressLatitude: 0.0,
      PrimaryAddressLongitude: 0.0,
      MaillingAddressLatitude: 0.0,
      MaillingAddressLongitude: 0.0,
      additionalAddressArray: [],
      primary_address_Address1: null,
      mailing_address_Address1: null,      
      // isFirstTime: true,
      // additional_address_route: [],
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.GetFullAddress = this.GetFullAddress.bind(this);
    this.IsFullAddressEmpty = this.IsFullAddressEmpty.bind(this);
    this.IsValidGoogleAddress = this.IsValidGoogleAddress.bind(this);    
  }

  componentWillMount() {
    let masterData = {
      'masterdata': 'MASTERWEEKDAYS,staffavailability,ADDRESSTYPE,MASTERSTATE,MASTERCOUNTRY,MASTERPATIENTLOCATION,PHONETYPE,MASTERPHONEPREFERENCES',
    };
    this.props.getPatientMasterData(masterData);
    this.props.getPatientAddressPhoneDetails(this.state.patientId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.patientMasterData && this.props.patientMasterData !== nextProps.patientMasterData) {
      let masterData = nextProps.patientMasterData;
      let primaryAddressTypeID = null;
      let mailingAddressTypeID = null;
      let filteredMasterAddressType = [];
      // let filteredPrimaryStatesByCountry = [];
      // let filteredMailingStatesByCountry = [];

      if (masterData.masterAddressType) {
        masterData.masterAddressType.map((obj, index) => {
          if (obj.value.toUpperCase() === 'PRIMARY HOME') {
            primaryAddressTypeID = obj.id;
          } else if (obj.value.toUpperCase() === 'MAILING HOME') {
            mailingAddressTypeID = obj.id;
          } else {
            filteredMasterAddressType.push(obj);
          }
          return { primaryAddressTypeID, mailingAddressTypeID, filteredMasterAddressType };
        });
      }

      // auto fill the primary and mailing states by the default country id = 1 (usa). please don't remove this
      // if (masterData.masterState) {
      //   filteredPrimaryStatesByCountry = masterData.masterState.filter((object) => object.countryID === 1);
      //   filteredMailingStatesByCountry = masterData.masterState.filter((object) => object.countryID === 1);
      // }

      // if (masterData.masterState && nextProps.initialValues && nextProps.initialValues.primary_address_Address1 !== this.props.initialValues.primary_address_Address1) {
      if (masterData.masterState) {
        this.setState({
          filteredPrimaryStatesByCountry: masterData.masterState.filter((object) => object.countryID === nextProps.initialValues.primary_address_CountryID),
        });
      }
      // if (masterData.masterState && nextProps.initialValues && nextProps.initialValues.mailing_address_Address1 !== this.props.initialValues.mailing_address_Address1) {
      if (masterData.masterState) {
        this.setState({
          filteredMailingStatesByCountry: masterData.masterState.filter((object) => object.countryID === nextProps.initialValues.mailing_address_CountryID),
        });
      }
      this.setState({
        masterState: masterData.masterState,
        filteredMasterAddressType: filteredMasterAddressType,
        masterCountry: masterData.masterCountry,
        primaryAddressTypeID: primaryAddressTypeID,
        mailingAddressTypeID: mailingAddressTypeID,
        masterLocationType: masterData.masterPatientLocation,
        masterPhoneType: masterData.masterPhoneType,
        masterPhonePreferences: masterData.masterPhonePreferences,
        // filteredPrimaryStatesByCountry: filteredPrimaryStatesByCountry,
        // filteredMailingStatesByCountry: filteredMailingStatesByCountry,
      });
    }

    if (nextProps.patientAddressPhoneDetails && nextProps.patientAddressPhoneDetails !== this.props.patientAddressPhoneDetails) {
      let patientAddressData = nextProps.patientAddressPhoneDetails.data && nextProps.patientAddressPhoneDetails.data.PatientAddress;
      // patientPhoneData = nextProps.patientAddressPhoneDetails.data && nextProps.patientAddressPhoneDetails.data.PhoneNumbers;

      let primaryAddressData = null,
        mailingAddressData = null,
        additionalAddress = [];

      (patientAddressData || []).map((address, index) => {
        if ((address.addressTypeName || '').toUpperCase() === 'PRIMARY HOME') {
          primaryAddressData = address;
        } else if ((address.addressTypeName || '').toUpperCase() === 'MAILING HOME') {
          mailingAddressData = address;
        } else {
          additionalAddress.push({
            'id': address.id,
            'Address1': address.address1 || '',
            'Latitude': address.latitude || 0,
            'Longitude': address.longitude || 0,
            'isMappedWithAppointment': address.isMappedWithAppointment || false,
            // 'AddressTypeID': address.addressTypeId || '',
            // 'ApartmentNumber': address.apartmentNumber || '',
            // 'City': address.city || '',
            // 'StateID': address.stateId || '',
            // 'Zip': address.zip || '',
            // 'CountryID': address.countryId || '',
            // 'PatientLocationID': address.patientLocationId || '',
          });
        }
        return { primaryAddressData, mailingAddressData, additionalAddress };
      });
      this.setState({
        additionalAddressArray: additionalAddress,
        primary_address_Address1: (primaryAddressData && primaryAddressData.address1) || '',
        PrimaryAddressLatitude: (primaryAddressData && primaryAddressData.latitude) || 0.0,
        PrimaryAddressLongitude: (primaryAddressData && primaryAddressData.longitude) || 0.0,
        mailing_address_Address1: (mailingAddressData && mailingAddressData.address1) || '',
        MaillingAddressLatitude: (mailingAddressData && mailingAddressData.latitude) || 0.0,
        MaillingAddressLongitude: (mailingAddressData && mailingAddressData.longitude) || 0.0,
      });
    }
    if (nextProps.saved_patientAddressPhoneDetails && nextProps.saved_patientAddressPhoneDetails !== this.props.saved_patientAddressPhoneDetails) {
      if (this.state.isTabChangeRequest) {
        this.setState({ isTabChangeRequest: false });
        this.props.handlePatientTabChange('4');
      } else {
        this.props.getPatientAddressPhoneDetails(this.state.patientId);
      }
    }
    // autofill country and state data for additonal address. please don't remove this
    if (nextProps.initialValues && nextProps.initialValues.AdditionalAddress && nextProps.initialValues !== this.props.initialValues) {
      nextProps.initialValues.AdditionalAddress.map((address, index) => {
        this.getFilteredAdditionalStatesList(address.CountryID, index);
        return true;
      });
    }
  }

  IsFullAddressEmpty(searchText, id) {
    if (id === 'primary_address_Address1' && searchText.length === 0) {    
        this.setState({ isValidPrimaryAddress: false, primary_address_Address1: null });      
    }
    else if (id === 'mailing_address_Address1' && searchText.length === 0) {
      this.setState({ isValidMailingAddress: false, mailing_address_Address1: null });      
    }
  }

  IsValidGoogleAddress(isValid, id) {
    if (id === 'primary_address_Address1') {    
      if(isValid)      
        this.setState({ isValidPrimaryAddress: true });            
      else
        this.setState({ isValidPrimaryAddress: false, primary_address_Address1: null });      
    }    
    else if (id === 'mailing_address_Address1') {
      if(isValid)      
        this.setState({ isValidPrimaryAddress: true });            
      else
        this.setState({ isValidPrimaryAddress: false, mailing_address_Address1: null });      
    }
  }

  GetFullAddress(componentForm, id) {

    if (id === 'primary_address_Address1') {
      this.setState({
        street_number: componentForm.street_number,
        route: componentForm.route,
        locality: componentForm.locality,
        administrative_area_level_1: componentForm.administrative_area_level_1,
        country: componentForm.country,
        postal_code: componentForm.postal_code,
        PrimaryAddressLatitude: componentForm.lat,
        PrimaryAddressLongitude: componentForm.lng,
        isValidPrimaryAddress: true,
      }, () => {
        this.props.dispatch(change('AddressForm', 'primary_address_City', this.state.locality === 'long_name' ? '' : this.state.locality));
        this.props.dispatch(change('AddressForm', 'primary_address_Zip', this.state.postal_code === 'short_name' ? '' : this.state.postal_code));
        let countryObj = extractDataFromArrayByValue(this.state.masterCountry, this.state.country === 'short_name' ? '' : this.state.country, true);
        if (countryObj) {
          this.props.dispatch(change('AddressForm', 'primary_address_CountryID', countryObj.id));
          this.getFilteredPrimaryStatesList(countryObj.id);
        }
        let stateObj = extractDataFromArrayByValue(this.state.filteredPrimaryStatesByCountry, this.state.administrative_area_level_1 === 'short_name' ? '' : this.state.administrative_area_level_1, false);
        if (stateObj) {
          this.props.dispatch(change('AddressForm', 'primary_address_StateID', stateObj.id));
        }
        let primary_address_Address1 = this.state.street_number === 'short_name' && this.state.route === 'long_name' ? '' :
          this.state.street_number === 'short_name' ? this.state.route : this.state.street_number + ' ' + this.state.route;

        this.setState({ primary_address_Address1: primary_address_Address1 });
      });
    } else if (id === 'mailing_address_Address1') {
      this.setState({
        street_number: componentForm.street_number,
        route: componentForm.route,
        locality: componentForm.locality,
        administrative_area_level_1: componentForm.administrative_area_level_1,
        country: componentForm.country,
        postal_code: componentForm.postal_code,
        MaillingAddressLatitude: componentForm.lat,
        MaillingAddressLongitude: componentForm.lng,
        isValidMailingAddress: true,
      }, () => {
        this.props.dispatch(change('AddressForm', 'mailing_address_City', this.state.locality === 'long_name' ? '' : this.state.locality));
        this.props.dispatch(change('AddressForm', 'mailing_address_Zip', this.state.postal_code === 'short_name' ? '' : this.state.postal_code));
        let countryObj = extractDataFromArrayByValue(this.state.masterCountry, this.state.country === 'short_name' ? '' : this.state.country, true);
        if (countryObj) {
          this.props.dispatch(change('AddressForm', 'mailing_address_CountryID', countryObj.id));
          this.getFilteredMailingStatesList(countryObj.id);
        }
        let stateObj = extractDataFromArrayByValue(this.state.filteredMailingStatesByCountry, this.state.administrative_area_level_1 === 'short_name' ? '' : this.state.administrative_area_level_1, false);
        if (stateObj) {
          this.props.dispatch(change('AddressForm', 'mailing_address_StateID', stateObj.id));
        }
        let mailing_address_Address1 = this.state.street_number === 'short_name' && this.state.route === 'long_name' ? '' :
          this.state.street_number === 'short_name' ? this.state.route : this.state.street_number + ' ' + this.state.route;

        this.setState({ mailing_address_Address1: mailing_address_Address1 });
      });
    } else {
      this.setState({
        street_number: componentForm.street_number,
        route: componentForm.route,
        locality: componentForm.locality,
        administrative_area_level_1: componentForm.administrative_area_level_1,
        country: componentForm.country,
        postal_code: componentForm.postal_code,
        // additionalAddressArray[i] : componentForm.lat
      }, () => {
        this.props.dispatch(change('AddressForm', `AdditionalAddress[${id}].City`, this.state.locality === 'long_name' ? '' : this.state.locality));
        this.props.dispatch(change('AddressForm', `AdditionalAddress[${id}].Zip`, this.state.postal_code === 'short_name' ? '' : this.state.postal_code));
        let countryObj = extractDataFromArrayByValue(this.state.masterCountry, this.state.country === 'short_name' ? '' : this.state.country, true);
        if (countryObj) {
          this.props.dispatch(change('AddressForm', `AdditionalAddress[${id}].CountryID`, countryObj.id));
          this.getFilteredAdditionalStatesList(countryObj.id, id);
        }
        let stateObj = {};
        if (this.state.filteredAdditionalStatesByCountry && this.state.filteredAdditionalStatesByCountry[id]) {
          stateObj = extractDataFromArrayByValue(this.state.filteredAdditionalStatesByCountry[id], this.state.administrative_area_level_1 === 'short_name' ? '' : this.state.administrative_area_level_1, false);
          if (stateObj) {
            this.props.dispatch(change('AddressForm', `AdditionalAddress[${id}].StateID`, stateObj.id));
          }
        }

        let addressName = this.state.street_number === 'short_name' && this.state.route === 'long_name' ? '' :
          this.state.street_number === 'short_name' ? this.state.route : this.state.street_number + ' ' + this.state.route;
        document.getElementById(`AdditionalAddress[${id}].Address1`).value = addressName;

        let additionalAddressArray = this.state.additionalAddressArray || [];

        if (Array.isArray(additionalAddressArray)) {
          additionalAddressArray.splice(id, 1, {
            Address1: addressName,
            Latitude: componentForm.lat,
            Longitude: componentForm.lng,
          });
        }
        // additionalAddressArray[id] && additionalAddressArray[id].City ? additionalAddressArray[id].City = this.state.locality === 'long_name' ? '' : this.state.locality : null;
        // additionalAddressArray[id] && additionalAddressArray[id].Zip ? additionalAddressArray[id].Zip = this.state.postal_code === 'short_name' ? '' : this.state.postal_code : null;
        // additionalAddressArray[id] && additionalAddressArray[id].CountryID ? additionalAddressArray[id].CountryID = countryObj.id : null;
        // additionalAddressArray[id] && additionalAddressArray[id].StateID ? additionalAddressArray[id].StateID = stateObj.id : null;

        // additionalAddressArray.splice(id, 0, {Latitude: componentForm.lat, Longitude: componentForm.lng});
        // additionalAddressArray.push({Latitude: componentForm.lat, Longitude: componentForm.lng});

        this.setState({
          additionalAddressArray: additionalAddressArray,
        });
      });
    }
  }

  componentWillUnmount() {
    this.setState = ({
      checked: false,
      primary_address: null,
      mailing_address: null,
      patientId: null,
      isAddAddress: false,
      masterState: [],
      masterCountry: [],
      masterLocationType: [],
      filteredPrimaryStatesByCountry: [],
      filteredMailingStatesByCountry: [],
      filteredAdditionalStatesByCountry: [],
      primaryAddressTypeID: null,
      filteredMasterAddressType: [],
      masterPhoneType: [],
      masterPhonePreferences: [],
    });
  }
  handleNewRequest = (input, selectedRecord) => {
    let splitedName = input.name.split('');
    let slicedName = splitedName[18];
    if (input.name === 'primary_address_CountryID') {
      this.getFilteredPrimaryStatesList(selectedRecord.value);
      if (this.state.checked === true) {
        this.getFilteredMailingStatesList(selectedRecord.value);
      }
    }
    if (input.name === 'primary_address_StateID') {
      if (this.state.checked === true) {
        input.onChange(selectedRecord.value);
        this.props.dispatch(change('AddressForm', 'mailing_address_StateID', this.props.primary_address_StateID));
      }
    }
    if (input.name === 'mailing_address_CountryID') {
      this.getFilteredMailingStatesList(selectedRecord.value);
    }
    if (input.name === `AdditionalAddress[${slicedName}].CountryID`) {
      this.getFilteredAdditionalStatesList(selectedRecord.value, slicedName);
    }
    input.onChange(selectedRecord.value);
  };

  getFilteredPrimaryStatesList = (countryID) => {
    this.setState((prevState, props) => {
      let allStates = this.props.patientMasterData ? this.props.patientMasterData.masterState : null;
      if (allStates && allStates.length) {
        let filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
        return {
          filteredPrimaryStatesByCountry: filteredStates,
        };
      }
    });
  }
  getFilteredMailingStatesList = (countryID) => {
    this.setState((prevState, props) => {
      let allStates = this.props.patientMasterData ? this.props.patientMasterData.masterState : null;
      if (allStates && allStates.length) {
        let filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
        return {
          filteredMailingStatesByCountry: filteredStates,
        };
      }

    });
  }
  getFilteredAdditionalStatesList = (countryID, index) => {
    this.setState((prevState, props) => {
      let allStates = this.props.patientMasterData ? this.props.patientMasterData.masterState : null;
      let filteredStates = [];
      if (allStates && allStates.length) {
        filteredStates = allStates.filter((Obj) => Obj.countryID === countryID);
      }
      let filteredAdditionalStatesByCountry = this.state.filteredAdditionalStatesByCountry;
      filteredAdditionalStatesByCountry[index] = filteredStates;
      return {
        filteredAdditionalStatesByCountry: filteredAdditionalStatesByCountry,
      };
    });
  }


  handleSaveContinue = (formData) => {
    this.setState({ isTabChangeRequest: true });
    this.onSubmit(formData);
  };

  onSubmit(formData) {
    if (this.state.primary_address_Address1 === null || this.state.primary_address_Address1 === '') {
      this.setState({ isValidPrimaryAddress: false });
      return null;
    }

    if (this.state.mailing_address_Address1 === null || this.state.mailing_address_Address1 === '') {
      this.setState({ isValidMailingAddress: false });
      return null;
    }
    let primaryAddressData = {
      'id': formData.primary_address_id || 0,
      'PatientID': this.state.patientId,
      'IsPrimary': true,
      'IsMailingSame': formData.IsMailingSame ? formData.IsMailingSame : false,
      'Address1': this.state.primary_address_Address1,
      'ApartmentNumber': formData.primary_address_ApartmentNumber,
      'City': formData.primary_address_City,
      'StateID': formData.primary_address_StateID,
      'Zip': formData.primary_address_Zip,
      'CountryID': formData.primary_address_CountryID,
      'AddressTypeID': this.state.primaryAddressTypeID,
      'PatientLocationID': formData.primary_address_PatientLocationID,
      'Latitude': this.state.PrimaryAddressLatitude,
      'Longitude': this.state.PrimaryAddressLongitude,
    };
    let mailingAddressData = {
      'id': formData.mailing_address_id,
      'PatientID': this.state.patientId,
      'IsMailingSame': formData.IsMailingSame ? formData.IsMailingSame : false,
      'Address1': this.state.mailing_address_Address1,
      'ApartmentNumber': formData.mailing_address_ApartmentNumber,
      'City': formData.mailing_address_City,
      'StateID': formData.mailing_address_StateID,
      'Zip': formData.mailing_address_Zip,
      'CountryID': formData.mailing_address_CountryID,
      'AddressTypeID': this.state.mailingAddressTypeID,
      'PatientLocationID': formData.mailing_address_PatientLocationID,
      'Latitude': this.state.MaillingAddressLatitude,
      'Longitude': this.state.MaillingAddressLongitude,
    };;
    // JSON data for adresses array.
    let patientAddressArray = [
      primaryAddressData,
      mailingAddressData,
    ];
    (this.props.additionalAddressDetailsArray || []).forEach((Obj) => {
      patientAddressArray.push({
        ...Obj,
        'isDeleted': true,
      });
    });
    (formData.AdditionalAddress || []).map((addressObj, index) => {
      // update case for patient Addresses ------
      let addressDetailObj = patientAddressArray.find((obj) => obj.id === addressObj.id && obj.isDeleted);
      if (addressDetailObj) {
        let addressIndex = patientAddressArray.indexOf(addressDetailObj);
        patientAddressArray[addressIndex] = {
          ...addressObj,
          id: addressDetailObj.id,
          patientId: this.state.patientId,
          Address1: (this.state.additionalAddressArray[index] && this.state.additionalAddressArray[index].Address1) || '',
          Latitude: (this.state.additionalAddressArray[index] && this.state.additionalAddressArray[index].Latitude) || 0,
          Longitude: (this.state.additionalAddressArray[index] && this.state.additionalAddressArray[index].Longitude) || 0,
          'isDeleted': false,
        };
      } else {
        patientAddressArray.push({
          ...addressObj,
          id: 0,
          patientId: this.state.patientId,
          Address1: (this.state.additionalAddressArray[index] && this.state.additionalAddressArray[index].Address1) || '',
          Latitude: (this.state.additionalAddressArray[index] && this.state.additionalAddressArray[index].Latitude) || 0,
          Longitude: (this.state.additionalAddressArray[index] && this.state.additionalAddressArray[index].Longitude) || 0,
          'isDeleted': false,
        });
      }
      return patientAddressArray;
    });


    let otherPhoneTypeObj = (this.state.masterPhoneType || []).find((obj) => obj.value.toUpperCase() === 'OTHER');
    let otherPhoneTypeId = otherPhoneTypeObj && otherPhoneTypeObj.id;
    // JSON data for phone array.
    let patientPhoneArray = (this.props.phoneDetailsArray || []).map((Obj) => {
      return {
        ...Obj,
        'isDeleted': true,
      };
    });
    formData.Phone.map((phoneObj) => {
      // update case for patient phones ------
      let phoneDetailIndex = patientPhoneArray.findIndex((obj) => obj.id === phoneObj.id && obj.isDeleted);
      if (phoneDetailIndex !== -1) {
        patientPhoneArray[phoneDetailIndex] = {
          ...phoneObj,
          'OtherPhoneNumberType': phoneObj.PhoneNumberTypeId === otherPhoneTypeId ? phoneObj.OtherPhoneNumberType : null,
          'isDeleted': false,
        };
      } else {
        patientPhoneArray.push({
          ...phoneObj,
          id: 0,
          patientId: this.state.patientId,
          'OtherPhoneNumberType': phoneObj.PhoneNumberTypeId === otherPhoneTypeId ? phoneObj.OtherPhoneNumberType : null,
          'isDeleted': false,
        });
      }
      return patientPhoneArray;
    });

    let postData = {
      patientId: this.state.patientId,
      patientAddress: patientAddressArray || [],
      phoneNumbers: patientPhoneArray || [],
    };
    // console.log(JSON.stringify(postData));
    this.props.savePatientAddressPhoneDetails(postData);
  }

  copyPrimaryAddress(e) {
    let CheckedSameMailing = e.target.checked;
    this.setState({ checked: CheckedSameMailing });
    if (!CheckedSameMailing) {
      this.setState({ isValidMailingAddress: false, mailing_address_Address1: '' });      
      this.props.dispatch(change('AddressForm', 'mailing_address_ApartmentNumber', null));
      this.props.dispatch(change('AddressForm', 'mailing_address_City', null));
      this.props.dispatch(change('AddressForm', 'mailing_address_StateID', null));
      this.props.dispatch(change('AddressForm', 'mailing_address_CountryID', this.props.primary_address_CountryID));
      this.props.dispatch(change('AddressForm', 'mailing_address_Zip', null));
      this.props.dispatch(change('AddressForm', 'mailing_address_PatientLocationID', null));
      this.setState({ MaillingAddressLatitude: 0.0, MaillingAddressLongitude: 0.0 });
      this.getFilteredMailingStatesList(this.props.primary_address_CountryID);
    } else {
      this.setState({ isValidMailingAddress: true, mailing_address_Address1: this.state.primary_address_Address1 });
      // this.props.dispatch(change('AddressForm', 'mailing_address_Address1', this.state.primary_address_Address1));
      this.props.dispatch(change('AddressForm', 'mailing_address_ApartmentNumber', this.props.primary_address_ApartmentNumber));
      this.props.dispatch(change('AddressForm', 'mailing_address_City', this.props.primary_address_City));
      this.props.dispatch(change('AddressForm', 'mailing_address_StateID', this.props.primary_address_StateID));
      this.props.dispatch(change('AddressForm', 'mailing_address_CountryID', this.props.primary_address_CountryID));
      this.props.dispatch(change('AddressForm', 'mailing_address_Zip', this.props.primary_address_Zip));
      this.props.dispatch(change('AddressForm', 'mailing_address_PatientLocationID', this.props.primary_address_PatientLocationID));
      this.setState({ MaillingAddressLatitude: this.state.PrimaryAddressLatitude, MaillingAddressLongitude: this.state.PrimaryAddressLongitude });
      this.getFilteredMailingStatesList(this.props.primary_address_CountryID);
    }
  }
  addPhoneRow = () => { };
  removePhoneRow = (i) => { };
  addAddressRow = () => { };
  removeAddressRow = (i) => { };

  addAddressField = () => {
    this.setState({ isAddAddress: true });
  };

  renderPhoneTemplate = ({ fields }) => {
    this.addPhoneRow = (e) => {
      fields.push({});
    };

    this.removePhoneRow = (i, e) => {
      fields.remove(i);
      // this.state.additionalAddressArray.splice(i, 1);
    };
    let phoneTypeArray = [];
    if (this.props.Phone && this.props.Phone.length > 0) {
      this.props.Phone.map((phoneObj, index) => {
        phoneTypeArray.push({});
        if (this.props.patientMasterData && this.props.patientMasterData.masterPhoneType) {
          let masterPhoneType = this.props.patientMasterData.masterPhoneType;
          masterPhoneType.map((masterAddType, masterIndex) => {
            if (phoneObj.PhoneNumberTypeId === masterPhoneType[masterIndex].id) {
              phoneTypeArray[index] = masterAddType;
            }
            return phoneTypeArray;
          });
        }
        return phoneTypeArray;
      });
    };

    return (
      <div>
        {fields.map((Phone, i) => {
          let isOtherPhoneType = phoneTypeArray[i] && phoneTypeArray[i].value && phoneTypeArray[i].value.toUpperCase() === 'OTHER';

          return (<div id="currentDiv" className="row pdr-40 parent_div" key={i}>
            <div className={`${isOtherPhoneType ? 'col-sm-3' : 'col-sm-4'} require mt-35`}>
              <Field
                name={`Phone[${i}].PhoneNumberTypeId`}
                label="Contact Type"
                options={this.state.masterPhoneType}
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect} />
            </div>
            {isOtherPhoneType ?
              <div className="col-sm-3">
                <Field
                  name={`Phone[${i}].OtherPhoneNumberType`}
                  type="text"
                  maxLength="40"
                  label="Other Contact Type"
                  component={renderTextField} />
              </div>
              : null }
            <div className={`${isOtherPhoneType ? 'col-sm-3' : 'col-sm-4'} require`}>
              <Field
                name={`Phone[${i}].PhoneNumber`}
                type="text"
                maxLength="14"
                label="Phone Number"
                component={renderTextField}
                normalize={normalizeMobile}
              />
            </div>
            <div className={`${isOtherPhoneType ? 'col-sm-3' : 'col-sm-4'}  mt-35`}>
              <Field
                name={`Phone[${i}].PreferenceID`}
                options={this.state.masterPhonePreferences}
                label="Preference"
                handleNewRequest={this.handleNewRequest}
                component={renderAutoCompleteSingleSelect}
              />
            </div>
            {(fields.length - 1) === i ?
              <div>
                {fields.length > 1 ?
                  <button className="removeitem"
                    onClick={this.removePhoneRow.bind(this, i)} type="button" title="Remove Phone">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                  : ''}
                <button className="additem" onClick={() => this.addPhoneRow()} type="button" title="Add Phone">
                  <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                </button>
              </div>
              :
              <div>
                <button className="removeitem"
                  onClick={this.removePhoneRow.bind(this, i)} type="button" title="Remove Phone">
                  <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                </button>
              </div>
            }
          </div>);
        })
        }
      </div>
    );
  };


  renderAddressTemplate = ({ fields }) => {
    this.addAddressRow = () => {
      let arrayIndex = (this.props.AdditionalAddress && this.props.AdditionalAddress.length) || 0;
      let fieldName = `AdditionalAddress[${arrayIndex}].CountryID`;
      fields.push({});
      this.props.dispatch(change('AddressForm', fieldName, this.props.initialValues.primary_address_CountryID));
      this.getFilteredAdditionalStatesList(this.props.initialValues.primary_address_CountryID, arrayIndex);
    };

    this.removeAddressRow = (i, e) => {
      let additionalAddressArray = this.state.additionalAddressArray || [];
      if(additionalAddressArray[i].isMappedWithAppointment)
      {
        showErrorMessage('You cannot remove this, as it is associated somewhere in the application');        
      }
      else
      {
        additionalAddressArray.splice(i, 1);
        this.setState({ additionalAddressArray: additionalAddressArray });
        fields.remove(i);
      }
    };
    let addressTypeArray = [];
    if (this.props.AdditionalAddress && this.props.AdditionalAddress.length > 0) {
      this.props.AdditionalAddress.map((addAddress, index) => {
        addressTypeArray.push({});
        if (this.props.patientMasterData && this.props.patientMasterData.masterAddressType) {
          let masterAddressType = this.props.patientMasterData.masterAddressType;
          masterAddressType.map((masterAddType, masterIndex) => {
            if (addAddress.AddressTypeID === masterAddressType[masterIndex].id) {
              addressTypeArray[index] = masterAddType;
            }
            return addressTypeArray;
          });
        }
        return addressTypeArray;
      });
    };
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <div className="panel_title">
              <h3>Additional Address</h3>
              <i className="flaticon flaticon-placeholder"></i>
              <div className="additionalAddressBtn">
                <button className="addnum" type="button" title="Add Address" onClick={this.addAddressRow}>
                  <i className="fa fa-plus-square greenfont" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>

        </div>
        {fields.map((AdditionalAddress, i) =>
          <div key={i}>
            <div className="row">
              <div className="col-sm-4 pdl-40 require mt-35">
                <Field
                  name={`AdditionalAddress[${i}].AddressTypeID`}
                  label="Address Type"
                  options={this.state.filteredMasterAddressType}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
                {addressTypeArray[i] && (!addressTypeArray[i].value || addressTypeArray[i].value.toUpperCase() !== 'OTHER') ?
                  <div>
                    <button
                      onClick={this.removeAddressRow.bind(this, i)}
                      type="button" className="additem" title="Remove Address">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  </div>
                  : ''}
              </div>
              {addressTypeArray[i] && addressTypeArray[i].value && addressTypeArray[i].value.toUpperCase() === 'OTHER' ?
                <div className="col-sm-4 pdl-30 require">
                  <Field
                    name={`AdditionalAddress[${i}].Others`}
                    label="Other Address Type"
                    component={renderTextField} />
                  <div>
                    <button
                      onClick={this.removeAddressRow.bind(this, i)}
                      type="button" className="additem" title="Remove Address">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                  </div>
                </div>
                :
                ''
              }
            </div>
            <div className="row">
              <div className="col-sm-8 require">
                {/* <Field
                  name={`AdditionalAddress[${i}].Address1`}
                  type="text"
                  maxLength="55"
                  label="Address"
                  // normalize = {isValidNameWithSpace}
                  fullWidth={true}
                  component={renderTextField}/> */}
                <GooglePlaceAutocomplete
                  getFullAddress={(componentForm, id) => this.GetFullAddress(componentForm, `${i}`)}
                  id={`AdditionalAddress[${i}].Address1`}
                  name={`AdditionalAddress[${i}].Address1`}
                  labelText="Address"
                  value={this.state.additionalAddressArray[i] ? this.state.additionalAddressArray[i].Address1 : ''}
                  // errorText={isValidAddress ? '' : 'Invalid address. Please choose address from dropdown.'}
                  // isFullAddressEmpty={(searchText, id) => this.IsFullAddressEmpty(searchText, 'AdditionalAddress')}
                  // isValidGoogleAddress={(isValid, id) => this.IsValidGoogleAddress(isValid, 'AdditionalAddress')}
                />
              </div>
              <div className="col-sm-4">
                <Field
                  name={`AdditionalAddress[${i}].ApartmentNumber`}
                  type="text"
                  maxLength='15'
                  label="Apt/Unit"
                  normalize={isValidApartmentWithSpace}
                  component={renderTextField} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 require mt-35">
                <Field
                  name={`AdditionalAddress[${i}].CountryID`}
                  label="Country"
                  value={this.state.country}
                  options={this.state.masterCountry}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>
              <div className="col-sm-4 require">
                <Field
                  name={`AdditionalAddress[${i}].City`}
                  type="text"
                  maxLength="50"
                  disabled={true}
                  normalize={isValidNameWithSpace}
                  label="City"
                  component={renderTextField} />
              </div>
              <div className="col-sm-4 require mt-35">
                <Field
                  name={`AdditionalAddress[${i}].StateID`}
                  label="State"
                  disabled={(this.props.AdditionalAddress && this.props.AdditionalAddress[`${i}`] && !this.props.AdditionalAddress[`${i}`].CountryID)}
                  options={this.state.filteredAdditionalStatesByCountry[i]}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>

            </div>
            <div className="row">
              <div className="col-sm-4 require">
                <Field
                  name={`AdditionalAddress[${i}].Zip`}
                  type="text"
                  maxLength="10"
                  disabled={true}
                  label="Zip Code"
                  normalize={normalizeZipCode}
                  component={renderTextField} />
              </div>
              <div className="col-sm-8 require mt-35">
                <Field
                  name={`AdditionalAddress[${i}].PatientLocationID`}
                  label="Location Type"
                  fullwidth={true}
                  options={this.state.masterLocationType}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>
            </div>
          </div>
        )
        }
      </div>
    );
  };
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <div>
          <div className="panel_title mt-20">
            <h3>Primary Address</h3>
            <i className="flaticon flaticon-placeholder"></i>
          </div>
          <form className="readmin-form custom_form" noValidate onSubmit={handleSubmit(this.onSubmit.bind(this))}>
            <div className="row">
              <div className="col-sm-8 require">
                {/* <Field
                  autoFocus={true}
                  name="primary_address_Address1"
                  type="text"
                  maxLength="55"
                  label="Address"
                  // normalize = {isValidNameWithSpace}
                  fullWidth={true}
                  component={renderTextField}/> */}
                {/* {this.state.primary_address_Address1 != null || this.state.patientId === null ? */}
                <GooglePlaceAutocomplete
                  getFullAddress={(componentForm, id) => this.GetFullAddress(componentForm, 'primary_address_Address1')}
                  id="primary_address_Address1"
                  name="primary_address_Address1"
                  labelText="Address"
                  //errorText={this.state.isValidPrimaryAddress ? '' : 'Please enter primary address.'}
                  errorText={this.state.isValidPrimaryAddress ? '' : 'Invalid address. Please choose address from dropdown.'}
                  value={this.state.primary_address_Address1}
                  isFullAddressEmpty={(searchText, id) => this.IsFullAddressEmpty(searchText, 'primary_address_Address1')}
                  isValidGoogleAddress={(isValid, id) => this.IsValidGoogleAddress(isValid, 'primary_address_Address1')}
                />
                {/* : ''} */}
              </div>
              <div className="col-sm-4">
                <Field
                  name="primary_address_ApartmentNumber"
                  type="text"
                  maxLength='15'
                  label="Apt/Unit"
                  normalize={isValidApartmentWithSpace}
                  component={renderTextField} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 require mt-35">
                <Field
                  name="primary_address_CountryID"
                  label="Country"
                  value={this.state.country}
                  options={this.state.masterCountry}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>
              <div className="col-sm-4 require">
                <Field
                  name="primary_address_City"
                  type="text"
                  maxLength="50"
                  normalize={isValidNameWithSpace}
                  label="City"
                  disabled={true}
                  component={renderTextField} />
              </div>
              <div className="col-sm-4 require mt-35">
                <Field
                  name="primary_address_StateID"
                  label="State"
                  disabled={!this.props.primary_address_CountryID}
                  options={this.state.filteredPrimaryStatesByCountry}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>

            </div>
            <div className="row">
              <div className="col-sm-4 require">
                <Field
                  name="primary_address_Zip"
                  type="text"
                  maxLength="10"
                  label="Zip Code"
                  disabled={true}
                  normalize={normalizeZipCode}
                  component={renderTextField} />
              </div>
              <div className="col-sm-8 require mt-35">
                <Field
                  name={'primary_address_PatientLocationID'}
                  label="Location Type"
                  fullwidth={true}
                  options={this.state.masterLocationType}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>
            </div>
            <div className="panel_title rsmb-30">
              <h3>Mailing Address</h3>
              <i className="flaticon flaticon-location"></i>
              <span className="copy_adrs">
                <Field
                  name="IsMailingSame"
                  label="Same as Primary Address"
                  component={renderCheckBox}
                  value={this.state.mailing_address}
                  onChange={(e) => this.copyPrimaryAddress(e)} />
              </span>
            </div>
            <div className="row">
              <div className="col-sm-8 require">
                {/* <Field
                  name="mailing_address_Address1"
                  type="text"
                  maxLength="55"
                  label="Address"
                  // normalize = {isValidNameWithSpace}
                  fullWidth={true}
                  component={renderTextField}/> */}
                {/* {this.state.mailing_address_Address1 != null || this.state.patientId === null ? */}
                <GooglePlaceAutocomplete
                  getFullAddress={(componentForm, id) => this.GetFullAddress(componentForm, 'mailing_address_Address1')}
                  id="mailing_address_Address1"
                  name="mailing_address_Address1"
                  labelText="Address"
                  //errorText={this.state.isValidMailingAddress ? '' : 'Please enter mailing address.'}
                  errorText={this.state.isValidMailingAddress ? '' : 'Invalid address. Please choose address from dropdown.'}
                  value={this.state.mailing_address_Address1}
                  isFullAddressEmpty={(searchText, id) => this.IsFullAddressEmpty(searchText, 'mailing_address_Address1')}
                  isValidGoogleAddress={(isValid, id) => this.IsValidGoogleAddress(isValid, 'mailing_address_Address1')}
                />
                {/* : ''} */}
              </div>
              <div className="col-sm-4">
                <Field
                  name="mailing_address_ApartmentNumber"
                  type="text"
                  maxLength='15'
                  label="Apt/Unit"
                  normalize={isValidApartmentWithSpace}
                  component={renderTextField} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 require mt-35">
                <Field
                  name="mailing_address_CountryID"
                  label="Country"
                  options={this.state.masterCountry}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>
              <div className="col-sm-4 require">
                <Field
                  name="mailing_address_City"
                  type="text"
                  maxLength="50"
                  label="City"
                  disabled={true}
                  normalize={isValidNameWithSpace}
                  component={renderTextField} />
              </div>
              <div className="col-sm-4 require mt-35">
                <Field
                  name="mailing_address_StateID"
                  label="State"
                  disabled={!this.props.mailing_address_CountryID}
                  options={this.state.filteredMailingStatesByCountry}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-4 require">
                <Field
                  name="mailing_address_Zip"
                  type="text"
                  maxLength="10"
                  disabled={true}
                  normalize={normalizeZipCode}
                  label="Zip Code"
                  component={renderTextField} />
              </div>

              <div className="col-sm-8 require mt-35">
                <Field
                  name={'mailing_address_PatientLocationID'}
                  label="Location Type"
                  options={this.state.masterLocationType}
                  fullwidth={true}
                  handleNewRequest={this.handleNewRequest}
                  component={renderAutoCompleteSingleSelect} />
              </div>

            </div>
            <FieldArray name="AdditionalAddress" addAddressParent={this.addAddressParent} component={this.renderAddressTemplate} />

            <div className="panel_title">
              <h3>Phone Numbers</h3>
              <i className="flaticon flaticon-agenda"></i>
            </div>
            <FieldArray name="Phone" component={this.renderPhoneTemplate} />
            <div className="row">
              <div className="col-sm-12 pt20 btn_rt">
                <CommonButton type="submit" primary={true} disabled={this.props.loading} label={`${this.props.loading ? 'Loading' : 'Save'}`} />
                <CommonButton className="ml_15" primary={true} disabled={this.props.loading ? true : false} onTouchTap={handleSubmit(this.handleSaveContinue.bind(this))} label="Save & Continue" />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

// Decorate with connect to read form values
const selector = formValueSelector('AddressForm'); // <-- same as form name
function mapStateToProps(state) {
  let agencyName = state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '';
  let countryName = agencyName.toUpperCase() === CONVERGENCY ? 'Canada' : 'US';
  let initialValueData = {
    'primary_address_CountryID': state.patient.patientMasterData && state.patient.patientMasterData.masterCountry ? state.patient.patientMasterData.masterCountry.filter((obj) => obj.countryName === countryName)[0].id : null,
    'mailing_address_CountryID': state.patient.patientMasterData && state.patient.patientMasterData.masterCountry ? state.patient.patientMasterData.masterCountry.filter((obj) => obj.countryName === countryName)[0].id : null,
    'AdditionalAddress': [],
    'Phone': [{}],
  };
  let additionalAddress = [];
  let primaryAddressData = null;
  let mailingAddressData = null;

  let patientAddressData = [],
    patientPhoneData = [];

  if (state.patient.patientAddressPhoneDetails && state.patient.patientAddressPhoneDetails.data && state.patient.patientMasterData) {
    patientAddressData = state.patient.patientAddressPhoneDetails.data && state.patient.patientAddressPhoneDetails.data.PatientAddress;
    patientPhoneData = state.patient.patientAddressPhoneDetails.data && state.patient.patientAddressPhoneDetails.data.PhoneNumbers;

    patientPhoneData = (patientPhoneData || []).map((phoneDetail) => {
      return {
        id: phoneDetail.id,
        PhoneNumberTypeId: phoneDetail.phoneNumberTypeId,
        OtherPhoneNumberType: phoneDetail.otherPhoneNumberType,
        PhoneNumber: phoneDetail.phoneNumber,
        PreferenceID: phoneDetail.preferenceID,
      };
    });

    (patientAddressData || []).map((address, index) => {
      if ((address.addressTypeName || '').toUpperCase() === 'PRIMARY HOME') {
        primaryAddressData = address;
      } else if ((address.addressTypeName || '').toUpperCase() === 'MAILING HOME') {
        mailingAddressData = address;
      } else {
        additionalAddress.push({
          'id': address.id,
          'AddressTypeID': address.addressTypeId || '',
          'Address1': address.address1 || '',
          'ApartmentNumber': address.apartmentNumber || '',
          'City': address.city || '',
          'StateID': address.stateId || '',
          'Zip': address.zip || '',
          'CountryID': address.countryId || '',
          'PatientLocationID': address.patientLocationId || '',
          'Others': address.others || '',
          'isMappedWithAppointment': address.isMappedWithAppointment || false,
        });
      }
      return { primaryAddressData, mailingAddressData, additionalAddress };
    });

    if (primaryAddressData && mailingAddressData) {
      initialValueData = {
        'primary_address_id': (primaryAddressData && primaryAddressData.id) || 0,
        'primary_address_Address1': (primaryAddressData && primaryAddressData.address1) || '',
        'primary_address_ApartmentNumber': (primaryAddressData && primaryAddressData.apartmentNumber) || '',
        'primary_address_City': (primaryAddressData && primaryAddressData.city) || '',
        'primary_address_StateID': (primaryAddressData && primaryAddressData.stateId) || '',
        'primary_address_Zip': (primaryAddressData && primaryAddressData.zip) || '',
        'primary_address_PatientLocationID': (primaryAddressData && primaryAddressData.patientLocationId) || '',
        'primary_address_CountryID': (primaryAddressData && primaryAddressData.countryId) || '',
        'PrimaryAddressLongitude': (primaryAddressData && primaryAddressData.longitude) || 0.0,
        'PrimaryAddressLatitude': (primaryAddressData && primaryAddressData.latitude) || 0.0,

        'mailing_address_id': (mailingAddressData && mailingAddressData.id) || 0,
        'mailing_address_Address1': (mailingAddressData && mailingAddressData.address1) || '',
        'mailing_address_ApartmentNumber': (mailingAddressData && mailingAddressData.apartmentNumber) || '',
        'mailing_address_City': (mailingAddressData && mailingAddressData.city) || '',
        'mailing_address_StateID': (mailingAddressData && mailingAddressData.stateId) || '',
        'mailing_address_Zip': (mailingAddressData && mailingAddressData.zip) || '',
        'mailing_address_CountryID': (mailingAddressData && mailingAddressData.countryId) || '',
        'mailing_address_PatientLocationID': (mailingAddressData && mailingAddressData.patientLocationId) || '',
        'MaillingAddressLatitude': (mailingAddressData && mailingAddressData.latitude) || 0.0,
        'MaillingAddressLongitude': (mailingAddressData && mailingAddressData.longitude) || 0.0,

        'IsMailingSame': (mailingAddressData && mailingAddressData.isMailingSame) || false,
        'AdditionalAddress': additionalAddress,
      };
    }
    if (patientPhoneData && patientPhoneData.length) {
      initialValueData = {
        ...initialValueData,
        'Phone': patientPhoneData,
      };
    }
  }
  return {
    formMeta: getFormMeta('AddressForm')(state), // get field status (active, focused...)
    loading: state.patient.loading,
    initialValues: initialValueData,
    patientMasterData: state.patient.patientMasterData,
    phoneDetailsArray: patientPhoneData || [],
    additionalAddressDetailsArray: additionalAddress || [],
    patientAddressPhoneDetails: state.patient.patientAddressPhoneDetails,
    primary_address_Address1: selector(state, 'primary_address_Address1'),
    primary_address_ApartmentNumber: selector(state, 'primary_address_ApartmentNumber'),
    primary_address_City: selector(state, 'primary_address_City'),
    primary_address_StateID: selector(state, 'primary_address_StateID'),
    primary_address_CountryID: selector(state, 'primary_address_CountryID'),
    mailing_address_CountryID: selector(state, 'mailing_address_CountryID'),
    primary_address_Zip: selector(state, 'primary_address_Zip'),
    primary_address_PatientLocationID: selector(state, 'primary_address_PatientLocationID'),
    Phone: selector(state, 'Phone'),
    AdditionalAddress: selector(state, 'AdditionalAddress'),
    saved_patientAddressPhoneDetails: state.patient.saved_patientAddressPhoneDetails,
  };
}

Address = reduxForm({
  form: 'AddressForm',
  validate,
  enableReinitialize: true, // this is needed!!
})(Address);
export default connect(mapStateToProps, {
  getPatientPhoneById,
  getPatientAddressPhoneDetails,
  getPatientMasterData,
  savePatientAddressPhoneDetails,
  savePatientPhone,
  deletePatientAddress,
})(Address);



// WEBPACK FOOTER //
// ./src/modules/patients/address.js